import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useLanguage } from "@/context/LanguageContext";

export default function AdminPressCard({ t }) {
  const { lang } = useLanguage();
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => {
    api.get("/admin/press-contacts").then((r) => setData(r.data)).catch(() => {});
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const notify = async () => {
    if (!window.confirm(t("adminList.confirm"))) return;
    setBusy(true);
    try {
      const { data: res } = await api.post("/admin/press-notify");
      toast.success(`${t("adminList.sent")}: ${res.sent}`);
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="px-5 md:px-12 pb-16" data-testid="admin-press-card">
      <div className="border border-gold/50 p-8">
        <div className="flex flex-wrap items-start justify-between gap-6">
          <div>
            <div className="text-[10px] tracking-[0.3em] text-golddark">ADMIN</div>
            <h3 className="mt-2 font-display text-2xl font-bold tracking-tight">{t("adminList.title")}</h3>
            <p className="mt-2 font-mono text-4xl font-light text-golddark tabular-nums" data-testid="admin-press-total">
              {data ? data.total : "…"} <span className="text-sm text-muted-foreground">{t("adminList.total")}</span>
            </p>
          </div>
          <button
            onClick={notify}
            disabled={busy || !data || data.total === 0}
            data-testid="admin-press-notify-btn"
            className="px-6 py-3 bg-[#7D8C77] text-[#FAF8F5] text-[10px] tracking-[0.25em] font-semibold hover:bg-[#3C3735] disabled:opacity-40 transition-colors duration-200"
          >
            {busy ? t("common.loading").toUpperCase() : t("adminList.notify").toUpperCase()}
          </button>
        </div>
        {data && data.contacts.length > 0 ? (
          <div className="mt-6 max-h-48 overflow-y-auto border-t border-border/60" data-testid="admin-press-list">
            {data.contacts.map((c) => (
              <div key={c.email} className="flex flex-wrap gap-x-6 gap-y-1 py-3 border-b border-border/40 text-xs">
                <span className="font-mono text-[#3C3735]">{c.email}</span>
                {c.name && <span className="text-muted-foreground">{c.name}</span>}
                {c.outlet && <span className="text-golddark">{c.outlet}</span>}
                {c.notified && <span className="text-muted-foreground tracking-[0.2em]">{lang === "it" ? "AVVISATO" : "NOTIFIED"}</span>}
              </div>
            ))}
          </div>
        ) : (
          <p className="mt-6 text-xs text-muted-foreground" data-testid="admin-press-empty">
            {t("adminList.empty")}
          </p>
        )}
      </div>
    </div>
  );
}
